!function($, global){
    'use strict';

    var $links = $('.scrollspy-nav .nav-link');
    var $items = $links.parent();

    var CURRENT_CLASS = 'current-menu-item';

    $(global).on('activate.bs.scrollspy', function(){
        var $active = $links.filter('.active');

        if($active.length) {
            $items.removeClass(CURRENT_CLASS);
            $active.parent().addClass(CURRENT_CLASS);
        }
    });

}(jQuery, window);